import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import type { MatOptionSelectionChange } from '@angular/material/core';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { InputErrorsComponent } from '@comparit/core';
import { AddressService } from '../../services/address.service';
import type { PlzOrte } from '@comparit/common-api';
import { Observable } from 'rxjs';

@Component({
  selector: 'ui-address-zip-control',
  imports: [
    AsyncPipe,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    MatAutocomplete,
    MatOption,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatProgressSpinner,
    InputErrorsComponent,
  ],
  templateUrl: './address-zip-control.component.html',
  styleUrl: './address-zip-control.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressZipControlComponent implements OnInit {
  zipControl = input.required<FormControl<string | null>>();
  cityControl = input<FormControl<string | null>>();
  /** Passed in so a new PLZ clears the street and house number that belonged to the old one. */
  streetControl = input<FormControl<string | null>>();
  numberControl = input<FormControl<string | null>>();

  private addressService = inject(AddressService);

  protected zipResult$!: Observable<PlzOrte[] | undefined>;
  protected isLoading = this.addressService.selectIsLoadingZip();

  ngOnInit() {
    this.zipResult$ = this.addressService.selectCitiesByZipChanges(this.zipControl());
  }

  protected onZipCitySelect(item: PlzOrte, event: MatOptionSelectionChange) {
    // Material also fires this for the option being deselected; acting on it would write the
    // previous option's Ort.
    if (!event.isUserInput) return;

    this.streetControl()?.setValue('');
    this.numberControl()?.setValue('');

    const ctrl = this.cityControl();
    if (!ctrl || ctrl.getRawValue() === item.ort) return;
    ctrl.setValue(item.ort);
  }
}
